import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import vtrllogin from '@/components/vtrllogin'
import assetselection from '@/components/assetselection'
import homepage from '@/components/homepage'
import logout from '@/components/logout'
import logtimer from '@/components/logtimer'
import signlog from '@/components/signlog'
import prelogSummary from '@/components/prelogSummary'
import logsummary from '@/components/logsummary'
import profile from '@/components/profile'
import inspection from '@/components/inspection'
import changedutystatus from '@/components/changedutystatus'
import cycleRules from '@/components/cycleRules'
import sendLogs from '@/components/sendLogs'
import about from '@/components/about'
import addcompany from '@/components/addcompany'
import addasset from '@/components/addasset'
import editLogsView from '@/components/editLogsView'
import editStatusLogs from '@/components/editStatusLogs'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/v1//operator/login',
      name: 'VTRLLogin',
      component: vtrllogin
    },
    {
      path: '/v1/operator/login',
      name: 'VTRLLogin',
      component: vtrllogin
    },
    {
      path: '/assets/assetselection',
      name: 'asset-selection',
      component: assetselection
    },
    {
      path: '/operator/home-page',
      name: 'home-page',
      component: homepage
    },
    {
      path: '/operator/logout',
      name: 'logout',
      component: logout
    },
    {
      path: '/operator/log-timer',
      name: 'logtimer',
      component: logtimer
    },
    {
      path: '/operator/sign-log',
      name: 'signlog',
      component: signlog
    },
    {
      path: '/operator/pre-log-summary',
      name: 'prelogSummary',
      component: prelogSummary
    },
    {
      path: '/operator/log-summary',
      name: 'logsummmary',
      component: logsummary
    },
    {
      path: '/operator/profile',
      name: 'profile',
      component: profile
    },
    {
      path: '/asset/inspection',
      name: 'inspection',
      component: inspection
    },
    {
      path: '/asset/inspection/:id',
      name: 'inspection',
      component: inspection
    },
    {
      path: '/operator/changedutystatus',
      name: 'changedutystatus',
      component: changedutystatus
    },
    {
      path: '/operator/cyclerules',
      name: 'cyclerules',
      component: cycleRules
    },
    {
      path: '/operator/sendlogs',
      name: 'sendlogs',
      component: sendLogs
    },
    {
      path: '/operator/about',
      name: 'about',
      component: about
    },
    {
      path: '/operator/addcompany',
      name: 'addcompany',
      component: addcompany
    },
    {
      path: '/asset/addasset',
      name: 'addasset',
      component: addasset
    },
    {
      path: '/operator/edit-log',
      name: 'editLogsView',
      component: editLogsView
    },
    {
      path: '/operator/edit-status-log',
      name: 'editStatusLogs',
      component: editStatusLogs
    },
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js